// Author YuJiaBei
// Date 2020-08-07 16:27:20

import * as model from "@/model/em/archive/EmArchLaborCostStandModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmArchLaborCostStand(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_ARCHIVE_URL,
    })
    .buildStore()
